import React from 'react'
import HeaderTwo from './HeaderTwo'
// import Sidebar from '../Components/sidebar/Sidebar'
import MyTripR from '../Components/MyTripR'
import SidebarLayout from '../Components/sidebar/SidebarLayout'

const MyTrip = () => {
  return (
    <>
      <SidebarLayout>

        <HeaderTwo />
        <div id="wrapper" className="col-md-12">
          <div style={{ position: "relative" }}>
            {/* <Sidebar /> */}
            <MyTripR />
          </div>
        </div>
      </SidebarLayout>
    </>
  )
}

export default MyTrip